/**
 * Helper interface to let us access the route parameters in a typed way
 */
export interface IRouteParams {
    /**
     * The event id
     */
    eventID?: number;

    /**
     * The ID of the detail modal
     */
    id?: number | 'new';

    /**
     * The current view tab
     */
    tab?: string;

    /**
     * The current modal tab
     */
    subtab?: string;

    /**
     * If there is provided a code
     * @remarks This is used for the QR code for production
     */
    code?: string;
}

/**
 * Typed class for route parameterss
 * @remarks This is to make sure the types are correct and we can easily access the parameters. This should NEVER be exposed to the outside world
 */
export class RouteParams implements IRouteParams {
    /**
     * The event id
     */
    public eventID?: number;

    /**
     * The ID of the detail modal
     * @remarks If this is 'new' we are creating a new object and should only show an empty modal
     */
    public id?: number | 'new';

    /**
     * The current view tab
     */
    public tab?: string;

    /**
     * The current modal tab
     */
    public subtab?: string;

    /**
     * If there is provided a code
     * @remakrs This is used for the QR code for production
     */
    public code?: string;

    /**
     * The constructor for the route params
     * @param params
     */
    public constructor(params?: IRouteParams) {
        this.eventID = !isNaN(parseInt(params?.eventID?.toString() ?? '')) ? parseInt(params!.eventID!.toString()) : undefined;

        if (params?.id === 'new') {
            this.id = 'new';
        } else {
            this.id = !isNaN(parseInt(params?.id?.toString() ?? '')) ? parseInt(params!.id!.toString()) : undefined;

            // This is just to make sure we dont get a zero, then we handle it as a new object
            if (this.id === 0) {
                this.id = 'new';
            }
        }
        this.tab = (params?.tab ?? '') === '' ? undefined : params?.tab;
        this.subtab = (params?.subtab ?? '') === '' ? undefined : params?.subtab;
        this.code = (params?.code ?? '') === '' ? undefined : params?.code;
    }
}
